import { render } from "./CapitalDetails.vue?vue&type=template&id=e0396258&scoped=true"
import script from "./CapitalDetails.vue?vue&type=script&lang=js"
export * from "./CapitalDetails.vue?vue&type=script&lang=js"

import "./CapitalDetails.vue?vue&type=style&index=0&id=e0396258&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0396258"]])

export default __exports__